import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../Services/order.service';
import {TranslateService} from '@ngx-translate/core';
import {Order} from '../../../../back-office/Models/Order';
import {environment} from '../../../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgForm} from '@angular/forms';
import {throwError} from 'rxjs';
import {OrderItemProductFabricCollection} from '../../../../back-office/Models/OrderItemProductFabricCollection';
import {Option} from '../../../../back-office/Models/Option';

@Component({
  selector: 'app-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.scss']
})
export class ViewQuoteComponent implements OnInit {
  public orderId: number;
  public order: Order = new Order();
  public options = [];
  public priceItem = true;
  public customerPrice = true;
  public dealerPassword: string;
  public priceItemHasError = false;
  public baseURL = environment.absolutePath;
  public baseUrl = environment.apiUrl;
  public optionType: Option;

  @ViewChild('passwordModal', {static: false}) passwordModal = null;
  @ViewChild('passwordModalForm', {static: false}) passwordModalForm: NgForm;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private helper: Helper,
    private translate: TranslateService,
    private auth: AuthenticationService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        this.orderService.getOrder(this.orderId).subscribe((resp) => {
          this.order = resp;
          this.orderService.getOption(this.orderId).subscribe(option => {
            this.order.orderItems.forEach((orderItem) => {
              const orderItemId = orderItem.id;
              if (option[orderItemId] == null) {
                this.options.push([]);
              } else {
                this.options.push(Object.values(option[orderItemId]));
              }

            });
          });
        });
      }
    });

  }

  orderItemCount(index) {
    return parseInt(index) + 1;
  }

  public catchError(response) {
    const body: any = response.error;
    this.helper.popMessageDialog(this.translate.instant('auth.password_is_invalid'), this.translate.instant('auth.password_is_invalid'));
    this.priceItemHasError = true;
    this.passwordModalForm.reset();
    return throwError(body.errors);
  }
  getGeneratedInvoiceForThisOrder() {
    const kind = (this.customerPrice) ? 'customer' : 'dealer';
    this.orderService.getInvoiceForAnOrder(this.orderId, kind).subscribe((resp: {url: string, filename: string} | boolean) => {
      if (resp && typeof resp === 'object') {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('href', resp.url);
        el.setAttribute('download', resp.filename);
        el.click();
      }
    });
  }

  EditOrder() {
    this.router.navigateByUrl('dealer-system/order/' + this.orderId + '/edit');
  }

  getDealerPrice(event) {
    if (event) {
      this.customerPrice = true;
    } else {
      this.passwordModal.show();
    }
  }

  getCustomerPrice() {
    this.auth.checkPassword(this.dealerPassword).pipe(catchError(res => this.catchError(res))).subscribe(() => {
      this.passwordModal.hide();
      this.customerPrice = false;
      this.dealerPassword = null;
      this.passwordModalForm.reset();
    });
  }

  checkPasswordError() {
    if (this.priceItemHasError || !Helper.isDefined(this.dealerPassword) || (!this.priceItemHasError || Helper.isDefined(this.dealerPassword))) {
      this.priceItem = true;
    }
    this.passwordModal.hide();
  }

  checkChildOption(optionItem) {
    const children = [];
    this.order.orderItems.forEach(res => {
      const child = res.orderItemOptions.forEach(orderItemOption => {
        if (orderItemOption.parent && orderItemOption.parent['id'] == optionItem) {
          children.push(orderItemOption);
        }
      });

    });
  }

  checkHasChild(optionItem) {
    this.order.orderItems.forEach(res => {
      const child = res.orderItemOptions.forEach(orderItemOption => {
        if (orderItemOption.parent && orderItemOption.parent['id'] == optionItem) {
          return true;
        }
      });
    });
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null);
  }
}
